import { forwardRef, useContext } from "react";
import { Dialog, DialogTitle, Fade, Slide, useMediaQuery, useTheme } from "@mui/material";
import { BREAKPOINT, WIDTH } from "../../../constants/breakpoints";
import { Add, ArrowLeft2, ArrowRight2 } from "iconsax-react";
import ArrowIcon from "../arrow-icon/arrow-icon";
import { LocaleContext } from "../../../routing/LangRouter";

const Transition = forwardRef(function Transition(props, ref) {
    return WIDTH < BREAKPOINT ? <Slide direction="up" ref={ref} {...props} /> : <Fade ref={ref} {...props} />;
});

function BaseDialog({ children, title, open, handleClose, maxWidth, top, icon }) {
    const { locale } = useContext(LocaleContext);

    //responsive modal
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Dialog
            disablePortal={false}
            transitionDuration={{ exit: 0 }}
            closeAfterTransition={false}
            open={open}
            onClose={handleClose}
            keepMounted
            fullScreen={fullScreen}
            TransitionComponent={Transition}
            fullWidth
            maxWidth={maxWidth}
            scroll="paper"
            sx={{
                top: `${fullScreen ? top : "0"}`,
                "& .MuiDialogTitle-root": {
                    fontSize: "1.125rem",
                    fontWeight: "700",
                },
                ".MuiPaper-root": {
                    borderRadius: `${fullScreen ? (top === "auto" ? "10px 10px 0 0" : top === "0" ? "0px" : "10px 10px 0 0") : "10px"}`,
                },
                "& .MuiDialogTitle-root": {
                    padding: `${fullScreen ? "0.5rem" : "1rem 1.5rem"}`,
                    fontSize: `${fullScreen ? "0.875rem" : "1rem"}`,
                    fontWeight: 700,
                },
                "& .MuiDialogContent-root": {
                    padding: `${fullScreen ? "1rem 0.5rem" : "1rem 1.5rem"}`,
                },
            }}
        >
            {!!title && (
                <DialogTitle display="flex" alignItems="center">
                    {icon === "close" ? (
                        <Add className="close" size="32" color="var(--teal-color-18)" onClick={handleClose} cursor="pointer" />
                    ) : (
                        <ArrowIcon
                            icons={[ArrowRight2, ArrowLeft2]}
                            isExpanded={locale === "en"}
                            size="24"
                            color="var(--teal-color-18)"
                            handleClick={handleClose}
                             cursor="pointer"
                        />
                    )}
                    <span>{title}</span>
                </DialogTitle>
            )}
            {children}
        </Dialog>
    );
}

export default BaseDialog;
